import { useEffect, useState } from 'react';
import { loadScript } from '../utils';
import { GRecaptcha } from '../types/grecaptcha';

type GoogleRecaptchaProps = {
    key: string;
    callback?: (recaptcha: GRecaptcha) => void;
}

type GoogleRecaptcha = {
    isLoading: boolean;
    error: string | null;
    recaptcha: GRecaptcha | null
}

const useGoogleRecaptcha: (GoogleMapsProps: GoogleRecaptchaProps) => GoogleRecaptcha =
({ key, callback, ...rest}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setErrors] = useState<string | null>(null);
    const [recaptcha, setRecaptcha] = useState<GRecaptcha | null>(null);

    useEffect(() => {
        if (recaptcha) {
            return;
        }
        else if (window.grecaptcha) {
            setRecaptcha(window.grecaptcha);
            return;
        }
        
        setIsLoading(true);
        
        if (error) {
            setErrors(null);
        }
        
        const url = new URL('https://www.google.com/recaptcha/api.js');
        url.searchParams.append('render', key);
        
        Object.entries(rest).forEach(([key , value]) => {
            if (!value) {
                return;
            }

            url.searchParams.append(key, value);
        });
        
        loadScript({
            src: url.href,
            id: 'google-recaptcha',
            onLoad: () => {
                setIsLoading(false);
                setRecaptcha(window.grecaptcha);
                
                if (callback) {
                    callback(window.grecaptcha);
                }
            },
            onError: (event) => {
                setIsLoading(false);
                setErrors(`Error google.recaptcha script loading!`);

                console.error(event);
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return {
        isLoading,
        error,
        recaptcha,
    } as const;
};

export default useGoogleRecaptcha;